import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { AgentSeller, LoginRequest } from "@/types/auth";

export async function auth(payload: LoginRequest) {
  const { data } = await apiClient.post<ApiResponse<AgentSeller>>(
    "/api/Agent/login",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Login failed");
  }

  return data;
}

export async function logout(payload: { agentCompanySellerId: string }) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/Agent/logout",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Logout failed");
  }

  return data;
}
